import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import BlogDetailsLayout from '../section/blog/blogDetails/blogDetailsLayout';

const BlogDetailsPage = () => {
    <Helmet>
        <title>Blogs | Travel-Tech & Tourism Trends</title>
    </Helmet>

    let { id } = useParams();

    return (
        <>
            <BlogDetailsLayout id={id}/>
        </>
    );
}

export default BlogDetailsPage;